module.exports = __webpack_public_path__ + "img/magento-custom-development.dae7a2d7.webp";